export const FI = {
  preparing_zip: "Valmistellaan zip…",
  compressing: "Pakataan…",
  info_icon: "Kun projekti on merkitty valmiiksi, uusia jäseniä ei voi liittyä tai lisätä, ja kaikki keskusteluryhmät poistetaan käytöstä. Huomaa, että projekti sekä kaikki keskusteluryhmät ja tiedot pysyvät käytettävissä poistettuina käytöstä.",
  mark_is_done: "Haluatko varmasti merkitä projektin valmiiksi? Kun se on merkitty, uusia jäseniä ei voi liittyä tai lisätä, ja kaikki keskusteluryhmät poistetaan käytöstä. Huomaa, että projekti sekä kaikki keskusteluryhmät ja tiedot pysyvät käytettävissä poistettuina käytöstä.",
  mark_not_done: "Haluatko varmasti avata projektin uudelleen? Kun se on merkitty avatuksi, uusia jäseniä voi liittyä tai lisätä, ja kaikki keskusteluryhmät aktivoidaan uudelleen.",
  mark_as_completed: "Merkitse projekti valmiiksi",
  room_completed: "Projekti valmis",
  room_members: "Projektin jäsenet",
  deactivated_rooms: "Poistetut projektit",
  deactivated_chats: "Poistetut keskustelut",
  completed_rooms: "Valmiit projektit",
  request_to_join_a_room: 'Pyyntö liittyä projektiin',
  wants_to_rejoin_room: 'Username haluaa liittyä uudelleen projektiin Roomname.',
  invited_you_to_join_room: 'Username kutsui sinut liittymään projektiin Roomname.',
  restart: "Käynnistä uudelleen",
  update_text: "Uusi päivitys on saatavilla. Napsauta käynnistä uudelleen asentaaksesi päivityksen.",
  update_availble: "Päivitys saatavilla",
  Loading: "Ladataan...",
  logout: "Kirjaudu ulos",
  back: 'Takaisin',
  company_list: "Yritysluettelo",
  followers: "Seuraajat",
  followings: "Seurattavat",
  article: "Artikkeli",
  companies: "Yritykset",
  one_to_one_chat: " Kahden välinen keskustelu",
  profile: "Profiili",
  company: "Yritys",
  company_selection: "Yrityksen valinta",
  home: "Etusivu",
  contact: "Yhteystieto ",
  add_company: "Lisää yritys ",
  add_project: "Lisää projekti ",
  capacities: "Kapasiteetit ",
  work_area: "Työalue",
  company_services: "Yrityksen palvelut",
  website: "Verkkosivusto",
  search_contacts: "Hae yhteystietoja",
  add_or_join_a_company: "Lisää tai liity yritykseen",
  follow: "Seuraa",
  following: "Seurataan",
  like: "Tykkää",
  company_contacts: "Yrityksen yhteystieto",
  leave_the_company: "Poistu yrityksestä",
  news: "Uutiset",
  earlier: "Aiemmin",
  action: "Toiminto",
  another_action: "Toinen toiminto",
  something_else: "Jotain muuta",
  search: "Haku",
  search_rooms: "Hae projekteja",
  search_articles: "Hae artikkeleita",
  contacts: "Yhteystiedot",
  suggestions: "Ehdotukset",
  project_list: "Projektiluettelo",
  search_results: "Hakutulokset",
  add_or_join_project: "Lisää tai liity projektiin",
  details: "Tiedot",
  your_position_within_company:
    "Valitse asemasi yrityksessä.",
  close_modal: "Sulje",
  map: "Kartta",
  or: "Tai",
  name: "Nimi*",
  street: "Katu*",
  house_number: "Talon nro",
  postal_code: "Postinumero",
  city: "Kaupunki*",
  opened_by: "Avannut:",
  project_No: "Projekti-nro: ",
  building_type: "Rakennustyyppi*",
  building_types: "Rakennustyyppi",
  add_join: "Lisää/Liity",
  mandatory_fiels: "*pakolliset kentät",
  invalid_fiels: "Tämä kenttä on pakollinen",
  add_or_join_company: "Lisää tai liity yritykseen",
  name_of_the_company: "Yrityksen nimi",
  edit_company_details: "Muokkaa yrityksen tietoja",
  branch_of_the_building_industry: "Rakennusalan toimiala",
  corporate_form: "Yritysmuoto",
  position_within_company: "Asema yrityksessä",
  request_confirmation: "Odottavat projektipyynnöt",
  company_e_mail: "Yrityksen sähköposti",
  type_of_filter: "Kirjoita suodattaaksesi...",
  setting: "Asetus",
  dashboard: "Hallintapaneeli",
  settings: "Asetukset",
  views: "Katselut",
  times_seen: "kertaa nähty",
  see_more: "...lisää",
  see_less: "...vähemmän",
  in_search: "haussa",
  reset_password: "Nollaa salasana",
  submit: "Lähetä",
  password: "Salasana",
  email: "Sähköposti",
  confirm_password: "Vahvista salasana",
  reset_email: "Nollaa sähköposti",
  update: "Päivitä",
  new_email: "Uusi sähköposti",
  kjuup_message: "Kjuup Viesti",
  delete_profile: "Poista profiili?",
  my_position: "Asemani:",
  add: "lisää",
  owner_company_admin: "Yrityksen järjestelmänvalvoja :",
  owner_company_admin_new: "Yrityksen järjestelmänvalvoja",
  mutual_contact: "yhteinen yhteystieto",
  mutual_contacts: "yhteiset yhteystiedot",
  co_owner: "Osaomistaja",
  managing_director: "Toimitusjohtaja",
  associate: "Yhtiökumppani",
  secretary: "Sihteeri",
  employee: "Työntekijä",
  project_manage: "Projektipäällikkö",
  auto_chat_translation: "Automaattinen keskustelun käännös",
  translate_room_group_names: "Käännä keskusteluryhmän nimet",
  translate_room_group_names_info: "Kun käytössä, keskusteluryhmien nimet käännetään automaattisesti käyttöliittymän kielelle.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Kun tämä on käytössä, Sähköposti-välilehti avautuu oletuksena Viestien sijaan sovelluksen avautuessa.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Kieli",
  english: "Englanti",
  german: "Saksa",
  french: "Ranska",
  italian: "Italia",
  change_language: "Vaihda kieli",
  my_companies: "Yritykseni",
  employees: "Työntekijät",
  invite_with_a: "Kutsu Kjuupiin",
  add_member: "Lisää jäsen",
  add_user: "Lisää käyttäjä",
  send_location: "Lähetä sijainti",
  assign_admin_rights: "Säädä järjestelmänvalvojan oikeuksia",
  deactivate_company: "Poista yritys käytöstä",
  remove_employees: "Poista työntekijät",
  remove_members: "Poista jäsenet",
  no_user_found: "Käyttäjää ei löytynyt!",
  approve: "Hyväksy!",
  deselect_all: "Poista kaikki valinnat",
  select_all: "Valitse kaikki",
  translation_on_building_projects: "Käännös projekteissa",
  reported_capacities: "Raportoidut palvelut",
  up_to_50m_exact: "Enintään 50m tarkkuudella",
  company_details_service: "Yrityksen palvelut",
  company_contact: "Yrityksen yhteystieto",
  invite_with_link: "Kutsu Kjuupiin",
  share_link: "Jaa linkki",
  share_company_link: "Jaa linkki",
  qr_code: "QR-koodi",
  copy_link: "Kopioi linkki",
  cancel_link: "Peruuta linkki",
  who_has_confirmed_services: "Kuka on vahvistanut palvelusi?",
  projectss: "Projektit",
  add_services: "Lisää palvelut",
  services: "Palvelut",
  save_text: "Tallenna",
  share_on: "Jaa:",
  articlen: "Artikkeli",
  invite_user_to_confirm_service:
    "Kutsu käyttäjiä vahvistamaan palvelut yritykselle.",
  link_copied: "Linkki kopioitu!",
  email_copied: "Sähköposti kopioitu!",
  personal_article: "Henkilökohtainen artikkeli",
  company_article: "Yrityksen artikkeli",
  characters_remaining: "Merkkejä jäljellä",
  optional_information: "Valinnainen tieto",
  project: "Projekti",
  projects: "Projektit...",
  abort: "Hylkää",
  preview: "Esikatselu",
  post: "Julkaise",
  of: "/",
  remove: "Poista",
  free_capacity: "Työportaali",
  current_status_overview: "Nykyisen tilan yleiskatsaus",
  report_capacities: "Raportoi palvelut",
  report_text: "Raportoi",
  search_capacities: "Etsi urakoitsijoita",
  add_project_user: "Lisää projektikäyttäjä",
  media: "Media",
  links: "Linkit",
  docs: "Dokumentit",
  featured_products: "Esitellyt tuotteet...",
  title: "Otsikko",
  text: "Teksti",
  feed_details: "Syötteen tiedot",
  add_employee: "Lisää työntekijä",
  latest: "Uusimmat",
  my_projects: "Projektini",
  cancel: "Peruuta",
  continue: "Jatka",
  role_in_the_building_industry: "Rooli rakennusalalla",
  als: "nimellä",
  join: "liity",
  find: "Etsi",
  request_to_join_a_company: "Pyyntö liittyä yritykseen",
  wants_to_join_the_company: "haluaa liittyä yritykseen",
  filter_by: "Suodata",
  ok: "Ok",
  close: "Sulje",
  weekly_statistics: "Viikkotilastot",
  is_following_you: "seuraa sinua.",
  as: "nimellä",
  has_joined_the: "on liittynyt yritykseen",
  has_looked_at_your_profile: "on katsonut profiiliasi.",
  time: "Aika",
  in_searches_in_past_week: "hauissa viime viikolla.",
  has_liked_your_article: "on tykännyt artikkelistasi.",
  has_published_a_new_article: "on julkaissut uuden artikkelin.",
  you: "Sinä",
  all_views: "Kaikki katselut",
  all_profile_views: "Kaikki profiilin katselut",
  mutual_company: "yhteinen yritys",
  artical_text: "Kirjoita artikkeli...",
  you_have_appeared: "Olet esiintynyt",
  your_request_at_the_company: "Pyyntösi yrityksessä",
  times_you_have_appeared_in_searches: "kertaa olet esiintynyt hauissa",
  appear_more_often_in_searches: "Esiinny useammin hauissa",
  you_have_been_found: "Sinut on löydetty",
  improve_profile: "Paranna profiilia",
  choose_existing_contact_for_single_chat:
    "Valitse olemassa oleva yhteystieto yksittäistä keskustelua varten:",
  in_order_to_add_new_contacts:
    "Lisätäksesi uusia yhteystietoja, etsi uusia yhteystietoja profiilisivulla.",
  times_in_searches_in_the_last_week:
    "kertaa hauissa viime viikolla. Päivitä profiilisi ja lisää lisätietoja, jotta sinut löydetään helpommin.",
  has_been_confirmed: "on vahvistettu.",
  have_joined_the: "ovat liittyneet  ",
  building_project: " rakennusprojektiin.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Valitse yritys, jota edustat. Tämä näytetään muille osallistujille.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Valitse yritys, jota edustat. Tämä näytetään muille osallistujille.",
  select_internal_section: "Valitse sisäinen osasto",
  select_profile_image: "Valitse profiilikuva",
  share_user: "Jaa käyttäjä",
  contact_sender_message:
    "Jaa tämä linkki kutsuaksesi Kjuupin ulkopuolisen jäsenen Kjuupiin. Tätä linkkiä voivat käyttää useat henkilöt rekisteröityäkseen.",
  project_sender_message:
    "Jaa tämä linkki kutsuaksesi Kjuupin ulkopuolisen jäsenen projektiin ”projektin nimi”. Tätä linkkiä voivat käyttää useat henkilöt rekisteröityäkseen ja liittyäkseen projektiin ”projektin nimi” Kjuupissa.",
  company_sender_message:
    "Jaa tämä linkki kutsuaksesi Kjuupin ulkopuolisen jäsenen yritykseen yrityksen nimi. Tätä linkkiä voivat käyttää useat henkilöt rekisteröityäkseen ja liittyäkseen yritykseen Kjuupissa.",
  contact_receivers_message:
    "Kutsulinkki liittyäksesi Kjuupiin. Napsauta linkkiä rekisteröityäksesi kjuupiin.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Jos asennat Kjuupin Apple App Storen kautta, sinun on napsautettava tätä linkkiä onnistuneen latauksen jälkeen voidaksesi rekisteröityä.",
  project_receivers_message:
    "Kutsulinkki liittyäksesi projektiin ”projektin nimi” Kjuupissa. Napsauta linkkiä rekisteröityäksesi Kjuupiin ja liittyäksesi projektiin ”projektin nimi”.",
  company_receivers_message:
    "Kutsulinkki yritykseen yrityksen nimi Kjuupissa. Napsauta linkkiä rekisteröityäksesi Kjuupiin ja liittyäksesi yritykseen yrityksen nimi.",
  sign_in: "Kirjaudu sisään",
  enter_your_email_add: "Syötä sähköpostiosoitteesi",
  forgot_password: "Unohditko salasanan",
  dont_have_account: "Eikö sinulla ole tiliä?",
  register: "Rekisteröidy",
  get_app: "Hanki sovellus",
  registration: "Rekisteröityminen",
  dep_ing: "DI",
  dr: "Tri",
  dr_ing: "TkT",
  dep_ing_arc: "DI Arkkitehti",
  prof: "Prof.",
  first_name: "Etunimi",
  last_name: "Sukunimi",
  have_an_account: "Onko sinulla tili?",
  when_register_you_agree: "Rekisteröityessäsi hyväksyt",
  term_of_use: "käyttöehdot",
  to: ".",
  in_our: "Meidän",
  data_policy: "tietosuojakäytännöissä",
  they_find_out: "selviää,",
  we_provide_store_data: "miten keräämme, käsittelemme ja tallennamme tietoja.",
  leaving_company_text:
    "Haluatko todella poistua yrityksestä? Poistuessasi yrityksestä poistut myös kaikista siihen liittyvistä projekteista ja keskusteluryhmistä. Voit liittyä näihin projekteihin uudelleen toisen yrityksen kanssa milloin tahansa.",
  delete_profile_text:
    "Haluatko todella poistaa profiilisi? Kun poistat profiilisi, kaikki yhteydet yrityksiin, projekteihin ja keskusteluihin poistetaan. Voit luoda uuden profiilin milloin tahansa.",
  confirm: "Vahvista",
  reject: "Hylkää",
  requet_to_leave: "Pyyntö poistua",
  choose: "Valitse",
  your_add_member: "Lisää jäsen",
  if_you: "jos",
  can_not_find: "et löydä yhteystietoasi täältä.",
  please_wait: "Odota...",
  imprint_gtc: "Yhteystiedot/Yleiset ehdot",
  register_confirm_popup: "Vahvista Kjuup-sähköpostiosoitteesi ennen kirjautumista. Olemme lähettäneet vahvistuslinkin. Jos et näe sitä, tarkista myös roskapostikansio.",
  PENDING_GROUP_USER:
    "saa viestit vasta sen jälkeen, kun kutsu projektiin on vahvistettu. Lisäviesti ilmestyy, kun kutsu projektiin on vahvistettu.",
  PENDING: "Kutsun vahvistus projektiin odottaa",
  denied_group_chat: " on hylännyt projektikutsun ja poistunut tästä ryhmästä.",
  // joined_group_chat: " on liittynyt huoneeseen ja tähän ryhmään.",
  joined_group_chat: " liittyi tähän ryhmään",
  you_joined_group_chat: "Liityit tähän ryhmään.",
  Others: "Muut",
  LEFT_GROUP: "on poistunut tästä keskusteluryhmästä.",
  YOU_LEFT_GROUP: "olet poistunut tästä keskusteluryhmästä.",
  days: "päivää",
  day: "päivä",
  hour: "tunti",
  hide_project: "Piilota projekti",
  hide_project_popup_text:
    "Jos piilotat projektit, niitä ei löydy Kjuupista. Vain projektin jäsenet voivat kutsua uusia käyttäjiä projektiin.",
  branch: "Toimiala",
  photo_video_media_lib: "Valokuva - Video mediakirjasto",
  document: "Dokumentti",
  location_meeting: "Sijainti / Kokous",
  all_member_of_project: "Kaikki projektin jäsenet",
  pending_request: "Odottavat projektipyynnöt",
  no_pending_request: "Odottavia pyyntöjä ei löytynyt!",
  news_feed: "Uutissyöte",
  user_info: "Ryhmän tiedot",
  leave_project: "Poistu projektista",
  media_link_docs: "Tiedostot",
  search_chat: "Hae keskustelua",
  export_chat_group: "Vie keskusteluryhmän tiedot viime kuulta",
  request_complete_chat_history: "Pyydä täydellinen keskusteluhistoria",
  leave_chat_group: "Poistu keskusteluryhmästä",
  add_user_project: "Lisää käyttäjä",
  me: "Minä",
  max_open_one_to_one:
    "Tällä hetkellä enintään 2 kahden välistä keskustelua voidaan avata rinnakkain ala- ja yläosassa. Yhteensä enintään 4 kahden välistä keskustelua on mahdollista.",
  are_you_sure_you_want_leave_chat:
    "Haluatko varmasti poistua tästä keskusteluryhmästä?",
  create_group: "Luo ryhmä",
  adding_members: "Lisätään jäseniä...",
  creating_the_chat: "Luodaan keskustelua...",
  finishing_setup: "Viimeistellään...",
  group_name: "Ryhmän nimi",
  by: "Lähettäjä:",
  mandetory: "*pakollinen",
  delteed: "on poistanut profiilinsa ja poistunut ryhmäkeskustelusta.",
  deleted_direct: "on poistanut profiilinsa ja poistunut keskustelusta.",
  unhidden_message:
    "Jos poistat projektien piilotuksen, kaikki Kjuupin jäsenet voivat löytää ne.",
  account_deleted: "Tili on poistettu.",
  refuse_company: "Haluatko varmasti hylätä yrityksen kutsun?",
  follow_additional: "Seuraa lisää käyttäjiä",
  f_add:
    "Seuraa Kjuupin lisää käyttäjiä, jotta ne ovat käytettävissä suorille viesteille.",
  c_inv: "Yrityksen kutsu(t)",
  invited_o_Company: "Sinut on kutsuttu liittymään yritykseen",
  refuse_companyX: "Haluatko varmasti hylätä yrityksen pyynnön?",
  a_Da: "Tili poistettu käytöstä.",
  has_deactivated: "on poistanut profiilinsa käytöstä.",
  reactive: "on aktivoinut profiilinsa uudelleen.",
  juup_note: "*Rekisteröityminen käyttäjätunnuksella on saatavilla vain Kjuup+ -jäsenille",
  username: "Käyttäjätunnus*",
  email_username: "Sähköposti/Käyttäjätunnus*",
  sPinText:
    "Anna 6-numeroinen turva-PIN-koodi. Tämä PIN-koodi tarvitaan, jos unohdat salasanasi, ja se on pakollinen tilisi vahvistamiseksi.",
  DeleteKjuupPlusText:
    "Haluatko todella poistaa profiilisi? Kun poistat profiilisi, kaikki yhteydet yrityksiin, projekteihin ja keskusteluihin poistetaan.\n\n48 tunnin kuluessa tilin poistamisesta voit aktivoida tilisi uudelleen kirjautumalla sisään käyttäjätunnuksella, salasanalla ja PIN-koodilla.",
  reactive_text:
    "Tilisi on poistettu. Napsauta Aktivoi uudelleen aktivoidaksesi tilisi uudelleen.",
  rac: "Aktivoi uudelleen",
  ac_ss: "Tili aktivoitu uudelleen onnistuneesti.",
  not_valid_pin: "PIN-koodi virheellinen",
  only_for_kjuup:
    "*Salasanan nollaus käyttäjätunnuksella ja PIN-koodilla on saatavilla vain Kjuup+ -jäsenille.",
  resetPIN: "Nollaa PIN-koodi",
  enter_current_pin: "Syötä nykyinen PIN-koodisi",
  enter_new: "Syötä uusi PIN-koodi",
  pin_to_confirm: "Anna PIN-koodi vahvistaaksesi.",
  change_username: "Nollaa käyttäjätunnus",
  pp_not_match: "Salasana - ja Vahvista salasana eivät täsmää",
  reactive_itself: "Olet aktivoinut profiilisi uudelleen.",
  has_deactivated_itself: "Olet poistanut profiilisi käytöstä.",
  more_than_two:
    "Tällä hetkellä suoria viestejä voidaan lähettää vain 2 käyttäjän kanssa rinnakkain.",
  Chats: "Suorat viestit",
  only_in_mobileL:
    "Alkuperäisiä videoita voidaan tällä hetkellä ladata ja julkaista vain mobiilisovelluksen kautta. Käytä Youtuben ja Vimeon videolinkkejä.",
  register_pin_text:
    "Valitse henkilökohtainen 6-numeroinen PIN-koodi. Tämä PIN-koodi tarvitaan tilin nollausominaisuuksien käyttöön.",
  internal_project: "Sisäinen",
  external_projects: "Ulkoinen",
  in_deacticted: "Sisäinen osasto on poistettu käytöstä.",
  create_article: "Luo artikkeli",
  new_article_selection: "Luo artikkeli ulkoiseen uutissyötteeseen",
  new_article_selection_internal: "Luo sisäinen artikkeli",
  active_trans_title: "Ota automaattinen käännös käyttöön?",
  active_trans: "Kun se on käytössä, kaikki saapuvat chat-viestit käännetään valitsemaasi sovelluksen kieleen.",
  disable_trans: "Haluatko todella poistaa automaattisen käännöksen käytöstä?",
  allow_access_chat: "Näytä täydellinen keskusteluhistoria",
  toggle_chat_history_on:
    "Haluatko todella, että käyttäjä näkee täydellisen keskusteluhistorian?",
  toggle_chat_history_off:
    "Haluatko todella, että käyttäjä näkee vain keskusteluhistorian keskusteluun liittymisestä lähtien?",
  check_selected_settings:
    "Tarkista keskusteluhistorian asetukset kaikille valituille käyttäjille!",
  chat_from_start_have:
    "Olet liittynyt tähän ryhmään. Keskusteluhistoria on jaettu.",
  chat_from_start_has:
    "on liittynyt tähän ryhmään. Keskusteluhistoria on jaettu.",
  Address: "Osoite",
  read_by: "Lukenut",
  deliver_to: "Toimitettu",
  remaining: "jäljellä",
  message_info: "Viestin tiedot",
  request_to_join_only: "Pyyntö liittyä",
  unfollow: "Lopeta seuraaminen",
  company_username: "Käyttäjätunnus",
  month: [
    "Tammi",
    "Helmi",
    "Maalis",
    "Huhti",
    "Touko",
    "Kesä",
    "Heinä",
    "Elo",
    "Syys",
    "Loka",
    "Marras",
    "Joulu",
  ],
  remove_my_admin_right: "Poista järjestelmänvalvojan oikeuteni",
  makeEmp: "Haluatko todella poistaa yrityksen järjestelmänvalvojan oikeudet käyttäjältä?",
  remove_my_self:
    "Haluatko todella poistaa yrityksen järjestelmänvalvojan oikeudet tililtäsi?",
  makeAdmin: "Haluatko todella antaa käyttäjälle yrityksen järjestelmänvalvojan oikeudet?",
  remove_member: "Poista jäsen",
  remove_following_confirm: "Haluatko todella poistaa {name} seurausten listalta?",
  remove_follower_confirm: "Haluatko todella poistaa {name} seuraajistasi? Jos poistat hänet, hänelle ei ilmoiteta.",
  do_you_really_want_to_remove:
    "Haluatko todella poistaa käyttäjätunnuksen yrityksestä?",
  invite_all: "Kutsu kaikki yrityksen jäsenet",
  invite_all_members: "Kutsu kaikki jäsenet",
  mems: "Kaikki muut jäsenet",
  dep_loc: "Osasto/Sijainti/Tiimi",
  depAdmin: "Osaston järjestelmänvalvoja",
  add_remove_admin: "Lisää/Poista yrityksen järjestelmänvalvojan asema",
  add_remove_dep_admin: "Lisää/Poista osaston järjestelmänvalvojan asema",
  remove_employees_dept: "Poista työntekijät kohteesta",
  want_to_join_dep:
    "Käyttäjätunnus haluaa liittyä yrityksen yrityksen nimi osastoon/sijaintiin/tiimiin osaston nimi.",
  you_invited:
    "Sinut on kutsuttu liittymään yrityksen yrityksen nimi osastoon/sijaintiin/tiimiin osaston nimi.",
  dep_remove:
    "Haluatko todella poistaa osaston tai sijainnin järjestelmänvalvojan oikeudet käyttäjältä?",
  add_dep:
    "Haluatko todella antaa käyttäjälle osaston tai sijainnin järjestelmänvalvojan oikeudet?",
  my_self_dep_remove:
    "Haluatko todella poistaa osaston järjestelmänvalvojan oikeudet tililtäsi?",
  member: "Jäsen",
  admin: "Järjestelmänvalvoja",
  remove_project_admin:
    "Haluatko todella poistaa jäsenen projektista?",
  remove_my_self_project: "Haluatko todella poistaa järjestelmänvalvojan oikeudet?",
  remove_member_admin_right:
    "Haluatko todella poistaa järjestelmänvalvojan oikeudet käyttäjältä?",
  add_member_admin_right: "Haluatko todella lisätä järjestelmänvalvojan oikeudet käyttäjälle?",
  add_remove_Poss: "Lisää/Poista järjestelmänvalvojan asema",
  forward: "Välitä",
  edit: "Muokkaa",
  only_kjuup_plus_can: "Vain Kjuup+ -yritykset voivat julkaista artikkeleita.",
  add_images: "Lisää kuva(t)",
  request_confirmation: 'Odottavat projektikutsut',
  Activity: "Toiminta",
  latest_messages: "Uusimmat viestit",
  hours: "tuntia",
  minute: "minuuttia",
  seconds: "sekuntia",
  days: "päivää",
  yesterday: "eilen",
  last_week: "viime viikolla",
  next_week: "ensi viikolla",
  Last_month: "viime kuussa",
  All: "Kaikki",
  register_plus: "Rekisteröityminen Plus",
  select_files: "Valitse tiedostot",
  monthsFullName: [
    "Tammikuu",
    "Helmikuu",
    "Maaliskuu",
    "Huhtikuu",
    "Toukokuu",
    "Kesäkuu",
    "Heinäkuu",
    "Elokuu",
    "Syyskuu",
    "Lokakuu",
    "Marraskuu",
    "Joulukuu",
  ],
  company_deploc_receivers_message:
    "Kutsulinkki yrityksen yrityksen nimi osastoon Kjuupissa. Napsauta linkkiä rekisteröityäksesi Kjuupiin ja liittyäksesi yritykseen yrityksen nimi.",
  no_news: "Ei uutisia",
  reminder: "Muistutus",
  np_reminder: "Ei tehtäviä",
  move_to_reminder: "Siirrä tehtäviin",
  remove_reminder: "Haluatko todella poistaa tämän viestin tehtäväluettelostasi?",
  remove_all_reminder: "Poista kaikki tehtävät",
  remove_all_confirm: "Haluatko todella poistaa kaikki viestit tehtäväluettelostasi?",
  remove_from_reminder: "Poista muistutuksesta",
  prevent_email: "Sähköpostia ei voi käyttää käyttäjätunnuksena.",
  allow_noti: "Salli ilmoitukset.",
  join_cap: "Liity",
  pass_minimum:
    "**Salasana vaatii 12 merkkiä, mukaan lukien pieni -, iso kirjain, numero ja erikoismerkki.",
  pass_error: "Tarkista salasanavaatimukset",
  people_that_like_article: "Ihmiset, jotka pitävät artikkelista.",
  people_who_like_article: "Ihmiset, jotka pitävät artikkelistasi.",
  message_delete: "Tämä viesti on poistettu.",
  message_edited: "muokattu",
  edit_message: "Muokkaa viestiä",
  edit_window_expired: "Viestejä voi muokata vain 10 minuutin kuluessa lähettämisestä.",
  message_edit_save: "Tallenna",
  copy: "Kopioi",
  bookmark: "Kirjanmerkki",
  add_reaction: "Lisää reaktio",
  delete_message: "Poista viesti",
  more_options: "Lisää asetuksia",
  info: "Tiedot",
  link_invite: "Kutsu linkin kautta",
  ll_nkk: "Kutsu Kjuupiin",
  selected: "Valittu",
  is_active: "Aktiivinen",
  inactive: "Ei-aktiivinen",
  last_online: "viimeksi paikalla {{when}}",
  remove_user_l: "Poista",
  link_expire: "Jokainen luotu linkki on voimassa 72 tuntia.",
  company_language: "Yrityksen kieli",
  company_language_info:
    "Kielivalintaa käytetään kaikissa yritykseen liittyvissä sähköpostivahvistuksissa.",
  s_image: "kuva",
  m_image: "kuvat",
  removeMsg: "Napauta poistaaksesi",
  block: 'Estä',
  unblock: 'Poista esto',
  blocks: 'Haluatko varmasti estää tämän käyttäjän?',
  unblocks: 'Haluatko varmasti poistaa tämän käyttäjän eston?',
  bolcked_click_un_block:
    'Olet estänyt tämän yhteystiedon. Napsauta tästä poistaaksesi eston.',
  you_have_unblocked: 'Olet poistanut tämän yhteystiedon eston.',
  you_have_blocked: 'Olet estänyt tämän yhteystiedon.',
  unblock_to_send: 'Poista käyttäjän esto lähettääksesi viestin.',
  pilot_text: "Erikoistunut tekoäly rakennusaiheisiin",
  startup_screen_label: "Aloitusnäyttö",
  startup_screen_info: "Valitse, mikä näyttö avautuu Kjuupin käynnistyessä.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Viestit",
  startup_screen_saved: "Aloitusnäyttö päivitetty",
email_on: "Sähköposti-ilmoitukset keskusteluista",
  email_on_grp: "Sähköposti-ilmoitus",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivoi tai poista käytöstä sähköposti-ilmoitukset tälle projektille. Tämä vaihtoehto on käytettävissä vain, kun \"Sähköposti-ilmoitukset keskusteluista\" on käytössä henkilökohtaisten asetusten kautta.",
  todo_notification_info: "Saat ilmoituksen aina, kun sinulle annetaan uusi tehtävä.",
  info_val: "Saat sähköpostin, jos uutta chat-viestiä ei lueta lyhyen ajan kuluessa. Voit poistaa sen käytöstä yksittäisille projekteille tai chateille niiden asetuksissa tai chatryhmän tiedoissa.",
  email_groups: "Aktivoi tai poista käytöstä sähköposti-ilmoitukset tälle keskustelulle. Tämä vaihtoehto on käytettävissä vain, kun \"Sähköposti-ilmoitukset keskusteluista\" on käytössä henkilökohtaisten - ja projektin asetusten kautta.",
  add_update_email: "Lisää/Päivitä sähköposti",
  text_to_verifiy: "\"Sähköposti-ilmoitukset keskusteluista\" -vaihtoehto voidaan ottaa käyttöön vain, jos sinulla on vahvistettu sähköpostiosoite tiedoissa.",
  stored_email: "Tallennettu sähköposti: ",
  verify_email: "Vahvistus odottaa!",
  join_call:"Liity",
  call_is_started:"Puhelu on alkanut",
  start_chat:"Aloita suora keskustelu?",
  project_rooms:"Projektit",
  download_selected:"Lataa",
  add_employee_confirm: 'Haluatko varmasti lisätä tämän käyttäjän yritykseen?',
  invalid_deeplink: "Virheellinen syvälinkin URL. Vaaditut parametrit puuttuvat.",
  deeplink_error: "Syvälinkin käsittely epäonnistui. Yritä myöhemmin uudelleen.",
  // Reply functionality translations
  reply: "Vastaa",
  reply_enter: "Kirjoita vastaus...",
  reply_sent_successfully: "Vastaus lähetetty onnistuneesti",
  reply_failed: "Vastauksen lähettäminen epäonnistui",
  reply_failed_generic: "Vastauksen lähettäminen epäonnistui. Yritä uudelleen.",
  replying_to_message: "Vastataan viestiin",
  cancel_reply: "Peruuta vastaus",
  voice_message: "Ääniviesti",
  send: "Lähetä",
  cancel: "Peruuta",
  type_your_reply: "Kirjoita vastauksesi...",
  
  // Auto-suggestion translations
  suggested_replies: "Ehdotetut vastaukset",
  suggestions_error: "Ehdotusten lataaminen epäonnistui",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Kuva — Napsauta ladataksesi",
  lazy_media_audio: "Ääniviesti — Napsauta ladataksesi",
  lazy_media_doc: "Asiakirja — Napsauta ladataksesi",
  lazy_media_video: "Video — Napsauta ladataksesi",
  suggestion_loading_message: "Hetki. Tekstiäsi valmistellaan yksilöllisesti sinulle.",
  loading_chat_message: "Ladataan keskustelua...",
  
  // Manual ToDo translations
  extracting_message: "Poimitaan viesti...",
  create_todo: "Luo tehtävä",
  create_todo_confirmation: "Haluatko luoda tehtävän tästä viestistä?",
  select_project_required: "Valitse projekti/ryhmä",
  only_assigned_can_change_status: "Vain määrätyt käyttäjät voivat muuttaa tilaa",
  todo_summary: "Yhteenveto",
  todo_summary_placeholder: "Kirjoita tehtävän yhteenveto...",
  todo_date: "Päivämäärä",
  todo_time: "Aika",
  todo_date_hint: "Jätä tyhjäksi käyttääksesi alkuperäisen viestin päivämäärää/aikaa",
  todo_created_success: "Tehtävä luotu onnistuneesti",
  todo_creation_failed: "Tehtävän luominen epäonnistui",
  create: "Luo",
  
  image: "kuva",
  images: "kuvat",
  remove_all_images: "Poista kaikki kuvat",
  remove_image: "Poista kuva",
  remove_document: "Poista dokumentti",
  remove_recording: "Poista nauhoitus",
  play_recording: "Toista nauhoitus",
  upload_image: "Lataa kuva",
  upload_document: "Lataa dokumentti",
  record_audio: "Nauhoita ääntä",
  stop_recording: "Lopeta nauhoitus",
  stop_recording_text: "Lopeta nauhoitus",
  please_remove_current_attachment: "Poista nykyinen liite",
  please_upload_image_file: "Lataa kelvollinen kuvatiedosto",
  please_upload_valid_document: "Lataa kelvollinen dokumenttitiedosto",
  searching_messages: "Etsitään viestejä...",
  loading_more: "Ladataan lisää...",
  loading_more_users: "Ladataan lisää käyttäjiä...",
  load_more_users: "Lataa lisää käyttäjiä",
  no_more_users_to_load: "Ei enää käyttäjiä ladattavaksi",
  no_messages_found: "Viestejä ei löytynyt",
  try_different_keyword: "Kokeile eri avainsanaa tai tarkista kirjoitusasu.",
  search_messages: "Hae viestejä, chat-ryhmiä, projekteja ja käyttäjiä...",
  todo: "Tehtävä",
  np_todo: "Ei tehtäviä",
  move_to_todo: "Tallenna tehtäväksi",
  remove_todo: "Haluatko todella poistaa tehtävän?",
  remove_all_todo: "Poista kaikki tehtävät",
  remove_all_todo_confirm: "Haluatko todella poistaa kaikki tehtävät?",
  add_to_todo: "Lisää tehtäviin",
  remove_from_todo: "Poista tehtävistä",
  confirm: "Vahvista",
  ok: "Ok",
  read_more: "Lue lisää",
  show_less: "Näytä vähemmän",
  show_more: "Näytä lisää",
  audio: "Ääni",
  video: "Video",
  // Notification Settings
  notification_schedule: "Ilmoitusaikataulu",
  notification_schedule_desc: "Saat push- ja sähköposti-ilmoituksia vain valitseminasi tunteina. Näiden aikojen ulkopuolella ne keskeytetään.",
  learn_more: "Lue lisää",
  allow_notifications: "Salli ilmoitukset:",
  every_day: "Joka päivä",
  weekdays: "Arkipäivät (maanantaista perjantaihin)",
  custom: "Mukautettu",
  monday: "Maanantai",
  tuesday: "Tiistai",
  wednesday: "Keskiviikko",
  thursday: "Torstai",
  friday: "Perjantai",
  saturday: "Lauantai",
  sunday: "Sunnuntai",
  to: "-",
  notification_settings: "Ilmoitukset",
  notification_settings_saved: "Ilmoitusasetukset tallennettu onnistuneesti",
  notification_settings_error: "Ilmoitusasetusten tallentaminen epäonnistui",
  unavailability_note: "Poissaoloilmoitus",
  unavailability_description: "Aseta poissaoloilmoitus. Kun se on aktiivinen, ilmoitus näytetään muille kaikissa keskusteluissasi ja ilmoitukset keskeytetään.",
  unavailability_start_date: "Alkamispäivä",
  unavailability_end_date: "Päättymispäivä",
  unavailability_message: "Viesti",
  unavailability_message_hint: "Käytä {endDate} paluupäivän paikkamerkkinä.",
  unavailability_replacement: "Varahenkilö",
  unavailability_replacement_placeholder: "Syötä käyttäjätunnus kiireellisille pyynnöille",
  unavailability_replacement_current: "Nykyinen varahenkilö",
  unavailability_replacement_hint: "Jos asetettu, poissaoloilmoituksessasi näytetään linkki tämän henkilön yhteystietoihin kiireellisiä asioita varten.",
  unavailability_replacement_none: "Ei varahenkilöä (valinnainen)",
  unavailability_contact_urgent: "Kiireellisissä asioissa ota yhteyttä",
  unavailability_default_message: "En ole tällä hetkellä toimistolla eikä minulla ole pääsyä Kjuupiin. Olen taas tavoitettavissa {endDate} alkaen ja palaan asiaan silloin.",
  unavailability_save: "Tallenna",
  unavailability_deactivate: "Poista käytöstä",
  unavailability_active_until: "Aktiivinen asti",
  unavailability_saved: "Poissaoloilmoitus tallennettu",
  unavailability_save_error: "Poissaoloilmoituksen tallennus epäonnistui",
  unavailability_deactivated: "Poissaoloilmoitus poistettu käytöstä",
  unavailability_end_date_required: "Päättymispäivä vaaditaan",
  start_time_before_end_time: "Aloitusajan on oltava ennen lopetusaikaa",
  loading: "Ladataan",
  disabled: "Poistettu käytöstä",
  enable: "Ota käyttöön",
  disable: "Poista käytöstä",
  forwarded: "Välitetty",
  message_forwarded: "Viesti välitetty!",
  // Schedule Article
  schedule_article_post: "Ajoita artikkelin julkaisu",
  date: "Päivämäärä",
  time: "Aika",
  scheduled_for_publication: "Ajoitettu julkaistavaksi",
  article_will_be_published_on: "Artikkeli julkaistaan:",
  reset_selection: "Nollaa valinta",
  continue: "Jatka",
  cancel: "Peruuta",
  // Member Selection
  error_loading_members: "Virhe ladattaessa jäseniä",
  please_fill_all_fields: "Täytä kaikki kentät",
  invalid_email: "Virheellinen sähköpostiosoite",
  member_added_successfully: "Jäsen lisätty onnistuneesti",
  error_onboarding_user: "Virhe lisättäessä käyttäjää",
  error_creating_chat: "Virhe luotaessa keskustelua",
  error_creating_group: "Virhe luotaessa ryhmää",
  new_group: "Uusi ryhmä",
  please_select_or_enter_group_name: "Valitse ryhmä tai kirjoita ryhmän nimi",
  please_select_or_enter_room_name: "Valitse projekti tai kirjoita projektin nimi",
  error_creating_room: "Virhe luotaessa projektia",
  error_opening_chat: "Virhe avattaessa keskustelua",
  privacy_modal_text: "Valitse \"Yksityinen\" vain, jos keskustelu ei sisällä projektipäällikölle merkityksellistä ammatillista sisältöä.",
  not_private: "Ei yksityinen",
  private: "Yksityinen",
  error_loading_groups: "Virhe ladattaessa ryhmiä",
  automatic_chat_export: "Automaattinen keskustelun vienti",
  automatic_chat_export_info: "Aktivoinnin jälkeen keskusteluhistoria lähetetään automaattisesti määritettyyn sähköpostiosoitteeseen joka kuukausi.",
  automatic_chat_export_no_email: "Ottaaksesi automaattisen keskustelun viennin käyttöön sinun on ensin lisättävä sähköpostiosoite. Voit lisätä sähköpostiosoitteesi henkilökohtaisissa asetuksissa.",
  enter_email: "Syötä sähköposti",
  update: "Päivitä",
  confirm: "Vahvista",
  export_to_email: "Vienti menee seuraavaan sähköpostiin.",
  start_chat_button:"Uusi viesti",
  matching_existing_chats: "Vastaavat olemassa olevat keskustelut",
  subject: "Aihe",
  add_subject: "Lisää aihe",
  chat_subject: "Keskustelun aihe:",
  set_project_room: "Aseta projekti",
  matching_existing_project_rooms: "Vastaavat olemassa olevat projektit",
  name_project_room: "Projektin nimi",
  professional_or_private: "Ammatillinen vai yksityinen",
  professional: "Ammatillinen",
  privacy_modal_text_updated: "Valitse \"Yksityinen\" vain, jos keskustelu ei sisällä projektipäälliköille merkityksellistä ammatillista sisältöä. Yksityiset keskustelut eivät näy projektipäälliköille.",
  create_internal_chat: "Ulkoinen - vai sisäinen keskustelu?",
  internal_chat_description: "Vain yrityksesi työntekijät voidaan lisätä sisäisiin keskusteluihin.",
  yes: "Kyllä",
  no: "Ei",
  chat_is_being_created: "Keskustelua luodaan...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Haluatko todella hylätä tämän artikkelin muutokset?",
  please_enter_article_title: "Kirjoita ensin artikkelin otsikko.",
  please_add_mandatory_fields: "Lisää kaikki pakolliset kentät",
  product_label: "Tuote:",
  no_companies_found: "Yrityksiä ei löytynyt",
  visible_to_all_followers: "Näkyvissä kaikille Kjuup-jäsenille",
  only_visible_to_employees: "Näkyvissä vain työntekijöille",
  something_went_wrong: "Jotain meni pieleen, yritä uudelleen",
  please_select_department: "Valitse osasto/sijainti",
  schedule: "Ajoita",
  please_select_future_date_time: "Valitse tuleva päivämäärä ja aika artikkelin ajoittamiseksi.",
  please_select_different_date_time: "Valitse eri päivämäärä tai aika artikkelin ajoittamiseksi.",
  please_select_later_time: "Valitse tänään myöhempi aika kuin nykyinen aika.",
  unpin_article: "Poista artikkelin kiinnitys",
  pin_article: "Kiinnitä artikkeli",
  and: "ja",
  others: "muut",
  at: "klo",
  // Chat mute/unmute translations
  mute: "Mykistä",
  unmute: "Poista mykistys",
  chat_muted_successfully: "Keskustelu mykistetty onnistuneesti",
  chat_unmuted_successfully: "Keskustelun mykistys poistettu onnistuneesti",
  mute_chat_confirm: "Haluatko todella mykistää tämän keskustelun? Et enää saa ilmoituksia uusista viesteistä.",
  unmute_chat_confirm: "Haluatko todella poistaa tämän keskustelun mykistyksen? Saat jälleen ilmoituksia uusista viesteistä.",
  please_select_group_to_forward: "Valitse ryhmä viestin välittämiseksi",
  // Company translations
  record_not_found: "Tietuetta ei löytynyt!",
  please_select_position: "Valitse asema",
  delete_article_confirm: "Haluatko varmasti poistaa tämän artikkelin?",
  delete_company_service_confirm: "Haluatko varmasti poistaa yrityksen palvelun?",
  block_translation_confirm: "Haluatko todella estää automaattisen käännöksen projekteissa kaikille yrityksen jäsenille",
  unblock_translation_confirm: "Haluatko todella poistaa automaattisen käännöksen eston projekteissa kaikille yrityksen jäsenille",
  please_select_file: "Valitse ladattava tiedosto",
  role_in_building_industry: "Rooli rakennusalalla*",
  invalid_email_address: "Virheellinen sähköpostiosoite",
  please_enter_password: "Syötä salasana",
  password_change_email_sent: "Sähköposti on lähetetty Kjuup-sähköpostiisi. Vahvista uusi salasanasi napsauttamalla vahvistuslinkkiä sähköpostissa.",
  please_enter_username: "Syötä käyttäjätunnus",
  username_same_as_before: "Käyttäjätunnus ei voi olla sama kuin aiemmin",
  profile_deleted_successfully: "Profiili poistettu onnistuneesti",
  hardware_requirements: "Laitteistovaatimukset",
  hardware_requirements_list: "• 4GB RAM<br/>• Prosessorin nopeus min. 2GHz<br/>• Windows 7 tai uudempi / kaikki macOS-versiot",
  submitting: "Lähetetään...",
  signing_in: "Kirjaudutaan sisään...",
  please_enter_service_name: "Syötä palvelun nimi",
  something_went_wrong_error: "Aaaah! Jotain meni pieleen...",
  something_went_wrong_try_again: "Anteeksi, jotain meni pieleen. Yritä uudelleen",
  position_label: "Asema:",
  loading_room: "Ladataan projektia...",
  navigating_to_room: "Siirrytään projektiin",
  loading_chat: "Ladataan keskustelua...",
  translate: "Käännä",
  show_original: "Näytä alkuperäinen",
  saving: "Tallennetaan...",
  language_selection_info: "Kielivalintaa käytetään kaikissa yritykseen liittyvissä sähköpostivahvistuksissa.",
  // Navigation bar labels
  nav_call: "Puhelu",
  nav_home: "Etusivu",
  nav_messages: "Viestit",
  nav_todo: "Tehtävät",
  nav_rooms: "Projektit",
  nav_all_rooms: "Kaikki projektit",
  pinned_rooms_max: "Voit kiinnittää enintään 10 projektia.",
  pinned_room_unpin: "Irrota",
  pinned_rooms_drop: "Vedä projektisi tähän pikaista valintaa varten",
  nav_profile: "Profiili",
  nav_company: "Yritys",
  nav_company_documents: "Asiakirjat",
  nav_logout: "Kirjaudu ulos",
  // Create message dialog
  add_member_title: "Lisää jäsen",
  continue_btn: "Jatka",
  search_placeholder: "Haku",
  no_members_found: "Jäseniä ei löytynyt",
  no_groups_found: "Ryhmiä ei löytynyt",
  no_rooms_found: "Projekteja ei löytynyt",
  search_users_tab: "Käyttäjät",
  search_documents_tab: "Asiakirjat",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Ei tiedostoja",
  no_documents_available: "No documents",
  searching_users: "Haetaan käyttäjiä...",
  no_users_found: "Käyttäjiä ei löytynyt",
  search_emails_tab: "Sähköposti",
  searching_emails: "Haetaan sähköposteja...",
  no_emails_found: "Sähköposteja ei löytynyt",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Nimeämätön ryhmä",
  unnamed_room: "Nimeämätön projekti",
  all_members: "Kaikki",
  room_label: "Projekti:",
  subject_label: "Aihe:",
  no_members: "Ei jäseniä",
  // Loading states for room creation
  creating_structure: "Luodaan rakennettasi",
  opening_chat: "Avataan keskustelua",
  please_wait: "Odota...",
  // ToDo page translations
  loading_todo: "Ladataan ToDo...",
  task_updated: "Tehtävä päivitetty",
  error_updating_task: "Virhe päivitettäessä tehtävää",
  task_deleted: "Tehtävä poistettu",
  error_deleting_task: "Virhe poistettaessa tehtävää",
  delete_task_confirm: "Haluatko varmasti poistaa tämän tehtävän?",
  description_label: "Kuvaus",
  description_placeholder: "Kirjoita kuvaus...",
  date_time_label: "Päivämäärä ja aika",
  save_hint: "Ctrl+Enter tallentaaksesi, Esc peruuttaaksesi",
  edit_label: "Muokkaa",
  delete_label: "Poista",
  todo_list_title: "Tehtävät",
  tasks_count: "tehtävät",
  search_placeholder_todo: "Haku...",
  select_task_to_open_chat: "Valitse tehtävä avataksesi keskustelun",
  today: "Tänään",
  yesterday: "Eilen",
  time_suffix: "", // Tyhjä suomeksi (24h-muoto ei tarvitse jälkiliitettä)
  from_chat: "Lähde tehtävä",
  assigned_to: "Määrätty",
  assign_users: "Määrää käyttäjiä",
  no_users_assigned: "Ei määrättyjä käyttäjiä",
  assign: "Määrää",
  assign_to: "Määrää...",
  navigate_to_chat: "Siirry keskusteluun",
  navigate_to_email: "Siirry sähköpostiin",
  show_original_message: "Näytä lähde",
  hide_original_message: "Piilota lähde",
  status_pending: "Odottaa",
  status_in_progress: "Käynnissä",
  status_completed: "Valmis",
  show: "Näytä",
  close: "Sulje",
  status_confirmed: "Vahvistettu",
  log_todo_created: "Tehtävä luotu",
  log_todo_confirmed: "Tehtävä vahvistettu",
  log_todo_deleted: "Tehtävä poistettu",
  log_todo_updated: "Tehtävä päivitetty",
  log_description_updated: "Kuvaus päivitetty",
  log_deadline_updated: "Määräaika päivitetty",
  log_assigned_to: "Määrätty {name}",
  log_unassigned_from: "Poistettu {name}",
  log_assignment_added: "Määräys lisätty: {name}",
  log_assignment_removed: "Määräys poistettu: {name}",
  log_status_updated: "Tila muutettu {from} tilaan {to}",
  log_status_changed: "Tila muutettu",
  log_status_changed_to: "Tila muutettu tilaan {status}",
  log_changed_status_to: "Muutti tilaksi:",
  log_for_user: "käyttäjälle:",
  log_user_updated_status: "Käyttäjä päivitti tehtävän tilan",
  log_changed_date_to: "Muutti päivämäärän:",
  log_changed_description_to: "Muutti kuvauksen:",
  log_moved_to: "Siirretty tilaan {status}",
  todo_status_updated_from: "tilasta",
  todo_status_updated_to: "tilaan",
  filter_pending: "Odottaa",
  filter_confirmed: "Vahvistettu",
  filter_assigned_to_me: "Omat tehtävät",
  filter_assigned_by_me: "Delegoitu",
  todo_project_label: "Projekti:",
  assigned_users: "Osoitetut käyttäjät:",
  todo_chat_label: "Keskustelu:",
  history: "Historia",
  todo_assigned_by: "Osoittanut:",
  todo_assigned_push: "ToDo osoitettu:",
  todo_assigned_push_empty: "Sinulle on osoitettu uusi ToDo.",
  search_groups: "Ryhmät",
  search_chat_groups: "Keskusteluryhmät",
  search_project_room: "Projekti",
  search_messages_tab: "Viestit",
  searching_groups: "Haetaan ryhmiä...",
  searching_rooms: "Haetaan projekteja...",
  no_groups_found: "Ryhmiä ei löytynyt",
  no_rooms_found: "Projekteja ei löytynyt",
  create_poll: "Kysely",
  poll_question_label: "KYSYMYS",
  poll_question_placeholder: "Esitä kysymys",
  poll_options_label: "VAIHTOEHDOT",
  poll_option: "Vaihtoehto",
  poll_add_option: "Lisää vaihtoehto",
  poll_allow_multiple: "Salli useat vastaukset",
  poll_multiple_allowed: "Valitse yksi tai useampi vaihtoehto",
  poll_select_option: "Valitse yksi vaihtoehto",
  poll_view_votes: "Näytä äänet",
  poll_vote_singular: "ääni",
  poll_vote_plural: "ääntä",
  poll_votes: "Kyselyn tulokset",
  poll_no_votes_yet: "Ei ääniä vielä",
  transcript_step_processing: "Litterointi käynnissä...",
  ai_transcript_tab: "AI-Litterointi",
  ai_transcript_info: "Saatavilla vain ääniviesteille, jotka on luotu 09.03.2026 jälkeen.",
  transcript_more: "...lisää",
  transcript_less: "...vähemmän",
  ki_transcript_voice_message: "KI-Ääniviestin litterointi",
  ki_image_analysis: "Tekoälyavusteinen kuva-analyysi",
  type_message: "Kirjoita viesti",
  email_tab_messages: "Viestit",
  email_tab_email: "Sähköposti",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Sähköpostitilit",
  email_connect_gmail: "Yhdistä Gmail",
  email_connect_outlook: "Yhdistä Outlook",
  email_no_accounts: "Ei yhteydessä olevia sähköpostitilejä",
  email_no_accounts_hint: "Yhdistä sähköpostitili profiiliasetuksissasi",
  email_no_messages: "Ei sähköposteja",
  email_from: "Lähettäjä",
  email_to: "Vastaanottaja",
  email_subject: "Aihe",
  email_disconnect: "Katkaise yhteys",
  email_disconnect_confirm: "Haluatko varmasti irrottaa tämän sähköpostitilin? Kaikki synkronoidut sähköpostit poistetaan.",
  email_account_disconnected: "Sähköpostitili irrotettu onnistuneesti",
  email_account_disconnect_failed: "Tilin irrottaminen epäonnistui",
  email_connecting: "Yhdistetään...",
  email_account_connected: "Tili yhdistetty onnistuneesti",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Siirry asetuksiin",
  email_date: "Päivämäärä",
  email_reply: "Vastaa",
  email_forward: "Välitä",
  email_copy_text: "Kopioi teksti",
  email_text_copied: "Kopioitu!",
  email_text_copy_failed: "Tekstiä ei voitu kopioida.",
  email_delete: "Poista",
  email_not_spam: "Ei roskapostia",
  email_not_spam_success: "Sähköposti siirretty saapuneisiin.",
  email_not_spam_failed: "Siirto saapuneisiin epäonnistui.",
  email_delete_confirm: "Haluatko varmasti poistaa tämän sähköpostin?",
  email_delete_from_folder: "Haluatko varmasti poistaa kansiosta {folder}?",
  email_delete_permanent_from_folder:
    "Haluatko varmasti poistaa pysyvästi kansiosta {folder}? Tätä toimintoa ei voi perua.",
  email_save_draft_confirm: "Haluatko tallentaa tämän sähköpostin luonnokseksi?",
  email_save_draft: "Tallenna luonnos",
  email_discard: "Hylkää",
  email_back_to_compose: "Palaa kirjoittamaan",
  email_draft_saved: "Luonnos tallennettu.",
  email_draft_save_failed: "Luonnoksen tallennus epäonnistui.",
  email_loading: "Ladataan sähköposteja...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Valitse",
  email_attachment_singular: "Liite",
  email_attachment_plural: "Liitteet",
  email_back: "Takaisin",
  email_download: "Lataa",
  email_close: "Sulje",
  email_preview: "Esikatselu",
  email_preview_not_available: "Esikatselu ei ole saatavilla",
  email_preview_failed: "Esikatselu ei ole saatavilla",
  select_attachments: "Valitse liitteet",
  email_loading_preview: "Ladataan esikatselua...",
  email_mark_unread_failed: "sähköpostia ei voitu merkitä lukemattomaksi.",
  email_delete_failed: "sähköpostia ei voitu poistaa.",
  filter_all: "Kaikki",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Suorat viestit",
  my_notes: "My Space",
  filter_internal_groups: "Sisäiset ryhmäkeskustelut",
  filter_external_groups: "Ulkoiset ryhmäkeskustelut",
  filter_group_chats: "Ryhmäkeskustelut",
  filter_groups_internal: "Sisäiset",
  filter_groups_external: "Ulkoiset",
  filter_unread_only: "Vain lukemattomat",
  room_daily_briefing_info: "Kun tämä on käytössä, tälle projektille luodaan raportti 24 tunnin välein henkilökohtaisissa asetuksissa määritettyyn aikaan — mutta vain, jos kyseisellä jaksolla on ollut toimintaa.",
  email_select_all: "Valitse kaikki",
  email_deselect_all: "Poista kaikki valinnat",
  email_reply_all: "Vastaa kaikille",
  email_reply_placeholder: "Kirjoita vastauksesi...",
  email_forward_placeholder: "Lisää viesti...",
  email_edit_draft: "Muokkaa luonnosta",
  email_attach: "Liitä",
  email_attachment_from_original: "Alkuperäisestä viestistä",
  email_remove: "Poista",
  email_drop_files: "Pudota tiedostot liitettäväksi",
  email_loading_attachments: "Ladataan liitteitä...",
  email_archive: "Arkistoi",
  mark_unread: "Merkitse lukemattomaksi",
  mark_read: "Merkitse luetuksi",
  email_all_accounts: "Kaikki tilit",
  email_error: "Virhe",
  email_delete_email_failed: "Sähköpostin poistaminen epäonnistui.",
  enter_url: "Syötä URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Tilaa nyt',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 KUUKAUDEN ILMAINEN KOKEILU',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Ei maksua tänään. Luottokorttitietoja ei kysytä ennen maksullisen tilauksen alkamista.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Hallitse kaikkia sähköpostitilejä suoraan Kjuupissa',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI kirjoittaa vastaukset – sinä vain vahvistat',
  kjuup_io_feature_tasks: 'Tehtävät ja kalenteri aina automaattisesti ajan tasalla',
  kjuup_io_choose_plan: 'Valitse suunnitelma',
  kjuup_io_plan_monthly: 'Kuukausittain',
  kjuup_io_plan_yearly: 'Vuosittain',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripen suojaama · irtisano milloin tahansa',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Maksu vastaanotettu. Tilausta aktivoidaan…',
  kjuup_io_toast_activating_soon: 'Maksu vastaanotettu. Tilauksesi aktivoituu pian.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} tuntia jäljellä',
  kjuup_io_trial_left_hour: '1 tunti jäljellä',
  kjuup_io_trial_left_minutes: '{count} minuuttia jäljellä',
  kjuup_io_trial_left_minute: '1 minuutti jäljellä',
  kjuup_io_trial_left_seconds: '{count} sekuntia jäljellä',
  kjuup_io_trial_left_second: '1 sekunti jäljellä',
  kjuup_io_trial_ending_now: 'Kokeilujaksosi päättyy…',
  kjuup_io_request_timeout: 'Yhteys aikakatkaistiin. Yritä uudelleen.',
  kjuup_io_info_days_free: '{days} päivää täysin ilmaiseksi – tilaus alkaa vasta kokeilujakson jälkeen.',
  kjuup_io_discount_total: 'Alennuksesi: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Henkilökohtainen: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Sulje',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Ilmainen kokeilujaksosi on päättynyt',
  kjuup_io_trial_ended_body: 'Tilaa Kjuup.io, niin voit jatkaa sähköpostin ja muiden premium-ominaisuuksien käyttöä.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Ilmainen kokeilujaksosi alkoi',
  kjuup_io_toast_trial_fail: 'Kokeilujakson aloittaminen epäonnistui',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / kuukausi',
  kjuup_io_save_amount_year: 'Säästä {price} vuodessa',
  kjuup_io_billed_annually_amount: '{price} laskutetaan vuosittain',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Mitä saat:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Luottokorttia ei tarvita – aloita heti ilman maksutietoja.',
  kjuup_io_info_cancel_anytime: 'Peruuta milloin tahansa – ei sitoumusta, ei riskiä.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Laskutusjakso',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Maksutapa tallennettu. Veloitus tehdään kokeilujakson päättyessä.',
  calendar_sync_info: 'Synkronoi automaattisesti kaikki Kjuup ToDo -tehtävät kalenteriisi.',
  calendar_no_accounts: 'Kalenteria ei ole vielä yhdistetty.',
  article_new_badge: 'UUSI',
  article_new_posts: '{0} uutta julkaisua',
  documents: 'Asiakirjat',
  add_documents: 'Lisää asiakirjoja',
  no_preview_available: 'Esikatselua ei ole saatavilla',
  no_preview_hint: 'Tätä tiedostotyyppiä ei voi esikatsella, mutta se lähetetään silti.',
  max_documents_reached: 'Voit liittää enintään 10 asiakirjaa kerrallaan.',
  open_file: 'Avaa tiedosto',
  twofa_title: 'Kaksivaiheinen tunnistus',
  twofa_method_totp: 'Tunnistussovellus',
  twofa_method_sms: 'Tekstiviesti',
  twofa_method_email: 'Sähköposti',
  twofa_enter_app: 'Anna 6-numeroinen koodi tunnistussovelluksestasi.',
  twofa_enter_sms: 'Anna 6-numeroinen koodi, jonka lähetimme tekstiviestillä.',
  twofa_enter_email: 'Anna 6-numeroinen koodi, jonka lähetimme sähköpostiisi.',
  twofa_resend: 'Lähetä koodi uudelleen',
  twofa_try_another: 'Kokeile toista tapaa',
  twofa_remember_device: 'Älä kysy tällä laitteella 30 päivään',
  twofa_sent: 'Lähetimme koodin.',
  twofa_invalid_code: 'Koodi on väärä. Yritä uudelleen.',
  twofa_something_wrong: 'Jokin meni pieleen. Yritä uudelleen.',
  twofa_method_unavailable: 'Tämä tapa ei ole käytettävissä.',
  twofa_on_desc: 'Kaksivaiheinen tunnistus on käytössä. Tarvitset koodin joka kirjautumisella.',
  twofa_off_desc: 'Lisää toinen vaihe salasanan jälkeen. Tunnistussovellukset ovat turvallisin vaihtoehto.',
  twofa_methods: 'Tavat',
  twofa_on: 'Käytössä',
  twofa_add: 'Lisää',
  twofa_default_method: 'Oletustapa',
  twofa_default: 'Oletus',
  twofa_turn_off: 'Poista käytöstä',
  twofa_disable_hint: 'Anna salasana ja nykyinen koodi poistaaksesi kaksivaiheisen tunnistuksen.',
  twofa_disable_need: 'Anna salasana ja vahvistuskoodi.',
  twofa_code_placeholder: '6-numeroinen koodi tai varakoodi',
  twofa_send_code: 'Lähetä koodi',
  twofa_primary_updated: 'Oletustapa on päivitetty.',
  twofa_disabled: 'Kaksivaiheinen tunnistus on nyt pois päältä.',
  twofa_enabled: 'Kaksivaiheinen tunnistus on nyt käytössä.',
  twofa_totp_help: 'Skannaa tämä QR-koodi Google Authenticatorilla, Authylla tai 1Passwordilla. Voit myös syöttää avaimen käsin.',
  twofa_secret_copied: 'Avain kopioitu',
  twofa_sms_help: 'Anna numerosi kansainvälisessä muodossa. Lähetämme 6-numeroisen koodin tekstiviestillä.',
  twofa_email_help: 'Lähetämme 6-numeroisen koodin tilisi sähköpostiosoitteeseen.',
  twofa_backup_title: 'Varakoodit',
  twofa_backup_help: 'Säilytä nämä kertakoodit turvallisessa paikassa. Jokainen koodi toimii kerran, jos puhelin katoaa.',
  twofa_copy_codes: 'Kopioi koodit',
  twofa_codes_copied: 'Varakoodit kopioitu',
  twofa_regenerate: 'Hae uudet varakoodit',
  twofa_regenerate_hint: 'Tämä korvaa käyttämättömät varakoodit. Anna salasanasi ja nykyinen koodi.',
  twofa_backup_remaining: '{n} käyttämätöntä varakoodia jäljellä',
  twofa_new_codes: 'Uudet varakoodit',
  twofa_sms_unavailable: 'Tekstiviestikoodit eivät ole vielä käytettävissä.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Sinulle annetut Kjuup-tehtävät kopioidaan Todoistin Kjuup-projektiin. Todoistissa tehdyt muutokset eivät kopioidu takaisin.",
  todoist_connect: "Yhdistä Todoist",
  todoist_connected: "Todoist yhdistetty",
  todoist_connect_failed: "Todoist-yhteys epäonnistui",
  todoist_disconnect: "Katkaise yhteys",
  todoist_disconnected: "Todoist-yhteys katkaistu",
  todoist_disconnect_confirm: "Katkaistaanko Todoist-yhteys? Todoistissa jo olevat tehtävät säilyvät. Synkronointi pysähtyy.",
  todoist_sync_now: "Synkronoi nyt",
  todoist_syncing: "Synkronoidaan…",
  todoist_sync_done: "Synkronointi valmis",
  todoist_sync_failed: "Synkronointi epäonnistui",
  todoist_auth_error: "Yhdistä Todoist uudelleen jatkaaksesi synkronointia.",
  todoist_last_sync: "Viimeisin synkronointi",
  todoist_not_connected: "Todoist ei ole yhdistetty",
  todoist_auth_url_failed: "Todoistin valtuutussivua ei voitu avata.",
  recommend_text: "Liity Kjuupiin, pysy yhteydessä ja pidä viestintäsi järjestyksessä. Kokoa kanavasi yhteen, pidä viestit oikeissa projekteissa ja aloita jokainen aamu yhteenvedolla ja tehtävilläsi – kaikki synkronoituna sovelluksiin, joita jo käytät. Aloita ilmaiseksi:",
  pro_auth_signin_title: 'Tervetuloa takaisin',
  pro_auth_signin_sub: 'Kirjaudu sisään työsähköpostillasi.',
  pro_auth_email_or_username: 'Sähköposti tai käyttäjätunnus',
  pro_auth_email_placeholder: 'nimi@yritys.fi',
  pro_auth_forgot_password: 'Unohditko salasanan?',
  pro_auth_create_account: 'Luo tili',
  pro_auth_show_password: 'Näytä salasana',
  pro_auth_hide_password: 'Piilota salasana',
  pro_auth_register_sub: 'Lähetämme sinulle linkin sähköpostisi vahvistamiseksi.',
  pro_auth_register_plus_sub: 'Valitse käyttäjätunnus ja salasana. Seuraavaksi asetat turva-PIN-koodisi.',
  pro_auth_check_credentials: 'Tarkista sähköpostisi ja salasanasi',
  pro_news_export_pdf: 'Vie PDF-muodossa',
  pro_news_pdf_failed: 'PDF-tiedostoa ei voitu luoda.',
  pro_news_pdf_attachments: 'Liitteet',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Syötä sähköpostisi, niin lähetämme sinulle linkin salasanan nollaamiseksi.',
  pro_auth_send_link: 'Lähetä nollauslinkki',
  pro_auth_plus_reset: 'Nollaa PIN-koodilla',
  pro_auth_show_pin: 'Näytä PIN',
  pro_auth_hide_pin: 'Piilota PIN',
  v2_auth_plus_only: 'Vain Kjuup+',
  room_action_media: "Tiedostot",
  room_tab_overview: "Yleiskatsaus",
  room_tab_history: "Historia",
  chat_info_media: "Tiedostot",
  messages: "viestit",
  pro_todo_project_required: "Valitse projekti",
  pro_todo_choose_project: "Mihin projektiin tehtävä kuuluu?",
  cockpit_report_delete_confirm: "Poistetaanko tämä päiväraportti?",
  cockpit_report_deleted: "Päiväraportti poistettu",
  cockpit_tab_company: "Yritys",
  cockpit_bookmarked_priorities: "Merkityt tehtävät",
  cockpit_load_error: "Cockpitin lataaminen epäonnistui.",
  cockpit_retry: "Yritä uudelleen",
  cockpit_yesterday: "Eilen",
  cockpit_greeting_morning: "Hyvää huomenta",
  cockpit_greeting_day: "Hyvää päivää",
  cockpit_greeting_evening: "Hyvää iltaa",
  cockpit_assistant_q_open: "Mikä on avoinna tänään?",
  cockpit_assistant_q_summarize: "Tee yhteenveto keskustelusta {{room}}",
  cockpit_assistant_q_overdue: "Mitkä tehtävät ovat myöhässä?",
  cockpit_assistant_new: "{{n}} uutta",
  cockpit_assistant_important: "{{n}} tärkeää",
  cockpit_assistant_title: "Kjuup-avustaja",
  cockpit_assistant_hint: "Napauta ja kysy",
  room_overview_priority_no_detail: "Raportissa ei ole lisätietoja tästä prioriteetista.",
  room_overview_priority_from: "Lähde: {{name}}",
  room_overview_priority_open_task: "Avaa tehtävä",
  cockpit_priority_position: "{{index}} / {{total}} prioriteettia",
  room_overview_today_title: "Tärkeää tänään",
  room_overview_all_tasks: "Kaikki",
  room_overview_tasks_empty: "Ei avoimia määräaikoja tai tehtäviä",
  room_overview_appointments_empty: "Ei tulevia tapaamisia",
  room_overview_no_priorities: "Ei avoimia prioriteetteja viimeisimmässä raportissa.",
  cockpit_report_top5: "Viisi tärkeintä prioriteettia",
  cockpit_report_todo_created: "Tehtävä luotu",
  cockpit_report_source_missing: "Lähdeviestiä ei löytynyt.",
  delete_bookmarked_priority_confirm: "Haluatko varmasti poistaa tämän merkityn tehtävän?",
  cockpit_report_create_todo: "Luo tehtävä",
  cockpit_priorities_deleting: "Poistetaan …",
  cockpit_priorities_select: "Poista useita",
  cockpit_report_none: "Ei merkintöjä.",
  cockpit_priorities_delete_confirm: "Haluatko varmasti poistaa {count} merkittyä tehtävää?",
  cockpit_priorities_delete_failed: "{count} tehtävän poistaminen epäonnistui",
  cockpit_priorities_deleted: "{count} tehtävää poistettu",
  cockpit_priorities_selected: "{count} valittu",
  cockpit_channel_connected: "Yhdistetty",
  cockpit_channel_not_connected: "Ei yhdistetty",
  cockpit_channel_connect: "Yhdistä",
  cockpit_channel_chat: "Kjuup-keskustelu",
  cockpit_channel_active: "Aktiivinen",
  cockpit_channel_hidden: "Piilotettu",
  cockpit_channel_enable: "Ota käyttöön",
  cockpit_channel_email: "Sähköposti",
  cockpit_channel_check: "Tarkista yhteys",
  cockpit_channel_fix: "Tarkista",
  cockpit_channel_forward: "Edelleenlähetysosoite",
  cockpit_channel_not_set_up: "Ei määritetty",
  cockpit_channel_set_up: "Määritä",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Yhteys katkennut",
  cockpit_channel_importing: "Tuodaan",
  cockpit_channel_removing: "Katkaistaan yhteyttä",
  cockpit_channel_reconnect: "Yhdistä uudelleen",
  cockpit_channels_title: "Kanavat",
  cockpit_company_role_super_admin: "Yrityksen ylläpitäjä",
  cockpit_company_role_dept_admin: "Osaston ylläpitäjä",
  cockpit_company_role_member: "Työntekijä",
  cockpit_company_none: "Kjuup+-yritystä ei löytynyt",
  cockpit_company_eyebrow: "Yritys",
  cockpit_company_inactive: "ei käytössä",
  cockpit_company_settings: "Yrityksen asetukset",
  cockpit_company_employees: "Työntekijät",
  cockpit_company_internal_rooms: "Sisäiset projektit",
  cockpit_report_all_projects: "Kaikki projektit",
  cockpit_report_progress_emails: "Analysoidaan sähköposteja",
  cockpit_report_progress_chats: "Analysoidaan keskusteluviestejä",
  cockpit_report_progress_documents: "Analysoidaan liitteitä ja asiakirjoja",
  cockpit_report_progress_tasks: "Analysoidaan tehtäviä",
  cockpit_report_progress_summarizing: "Analysoidaan sisältöä",
  cockpit_report_progress_reading: "Käytetään uudelleen jo analysoitua sisältöä",
  cockpit_report_progress_collecting: "Kerätään sähköposteja, keskusteluja ja tehtäviä projekteistasi",
  cockpit_report_progress_priorities: "Kootaan prioriteetit, määräajat ja päätökset",
  cockpit_report_progress_queued: "Valmistellaan raporttia",
  cockpit_report_creating_title: "Päiväraporttiasi valmistellaan",
  cockpit_report_progress_count_one: "1 kohde analysoitu",
  cockpit_report_progress_count_many: "{{count}} kohdetta analysoitu",
  cockpit_report_progress_hint: "Tämä kestää yleensä yhdestä kahteen minuuttia – voit käyttää cockpitia sillä välin.",
  cockpit_report_time_hint: "Päiväraportti luodaan joka päivä klo {{hour}}:00 viidelle aktiivisimmalle projektille.",
  room_overview_priorities_title: "Nykytila ja prioriteetit",
  room_overview_as_of: "Tilanne {{time}}",
  cockpit_report_delete: "Poista päiväraportti",
  email_tag_daily_briefing: "Päiväraportti",
  cockpit_report_unread: "Uusi",
  cockpit_report_clear_project: "Näytä kaikki projektit",
  cockpit_filter_project: "Projekti",
  cockpit_filter_all_projects: "Kaikki projektit",
  cockpit_report_recreate: "Luo päiväraportti uudelleen",
  cockpit_report_hide_previous: "Piilota aiemmat päiväraportit",
  cockpit_report_show_previous: "Näytä aiemmat päiväraportit",
  cockpit_report_room_empty: "Tälle projektille ei ole vielä päiväraporttia",
  cockpit_report_empty: "Ei vielä päiväraporttia",
  cockpit_report_room_empty_hint: "Luo päiväraportti vain tälle projektille.",
  cockpit_report_needs_mailbox: "Yhdistä sähköpostitili, jotta Kjuup voi luoda päiväraportin automaattisilla tehtävillä.",
  cockpit_report_create: "Luo päiväraportti",
  cockpit_email_connect: "Yhdistä sähköposti",
  cockpit_email_none_title: "Sähköpostitiliä ei ole vielä yhdistetty",
  cockpit_email_none_reports: "Yhdistä postilaatikkosi, jotta Kjuup voi kohdistaa saapuvat sähköpostit projekteihisi ja luoda päiväraportteja tehtävineen.",
  cockpit_email_none_client: "Yhdistä Gmail, Outlook tai IMAP lukeaksesi, kohdistaaksesi ja vastataksesi sähköposteihin suoraan Kjuup.iossa.",
  cockpit_email_reports_title: "Nykyinen sähköpostiohjelma",
  cockpit_email_reports_text: "Ei saapuneet-kansiota Kjuup.iossa · {{rooms}} projektia, päiväraportti klo {{hour}}:00 · saapuvat sähköpostit kohdistetaan projekteihisi.",
  cockpit_email_reports_rooms: "Hallitse projekteja",
  cockpit_email_settings: "Sähköpostiasetukset",
  cockpit_email_error_title: "Tarkista yhteys",
  cockpit_email_client_title: "Saapuneet yhdistetty",
  cockpit_email_accounts_n: "{{n}} tili yhdistetty",
  cockpit_email_last_sync: "viimeksi synkronoitu {{when}}",
  cockpit_email_report_at: "Päiväraportti klo {{hour}}:00",
  cockpit_email_open_inbox: "Avaa saapuneet",
  cockpit_email_eyebrow: "Kjuup-sähköposti",
  cockpit_email_accounts_label: "Yhdistetyt sähköpostiosoitteet",
  email_folder_sent: "Lähetetyt",
  email_no_subject: "(Ei aihetta)",
  cockpit_email_detail_loading: "Ladataan sähköpostia …",
  cockpit_email_detail_failed: "Sähköpostin lataaminen epäonnistui.",
  cockpit_email_detail_empty: "Tässä sähköpostissa ei ole tekstiä.",
  cockpit_personal_settings: "Henkilökohtaiset asetukset",
  cockpit_companies: "Yritykset",
  cockpit_title: "Cockpit",
  cockpit_back: "Takaisin yleiskatsaukseen",
  cockpit_day_overview: "Päiväsi pähkinänkuoressa",
  email_saved_to_project: "Sähköposti tallennettu projektiin",
  email_classify_need_project: "Anna projektin nimi",
  cockpit_email_deleted: "Sähköposti poistettu",
  cockpit_email_sent_empty: "Ei vielä lähetettyjä sähköposteja.",
  cockpit_email_incoming_empty: "Ei vielä saapuneita sähköposteja.",
  cockpit_email_incoming_title: "Sähköpostit",
  cockpit_email_incoming_sub: "Kohdista saapuvat ja lähetetyt sähköpostit projekteihisi. Voit muokata kohdistusta tässä.",
  cockpit_email_incoming_unassigned_n: "{{n}} kohdistamatta",
  cockpit_email_folder_inbox: "Saapuneet",
  cockpit_email_folder_sent: "Lähetetyt",
  cockpit_email_open: "Avaa sähköposti",
  cockpit_email_incoming_suggested: "Ehdotus: {{room}}",
  cockpit_email_incoming_apply: "Käytä",
  cockpit_email_incoming_adjust: "Muokkaa kohdistusta",
  cockpit_email_incoming_saving: "Tallennetaan …",
  cockpit_email_incoming_unassigned: "Ei kohdistettu",
  cockpit_email_incoming_show_less: "Näytä vähemmän",
  cockpit_email_incoming_show_all: "Näytä kaikki {{n}}",
  cockpit_io_settings: "Kjuup.io-asetukset",
  cockpit_io_settings_sub: "Tilaus ja paikat, työntekijöiden määritys, laskutus ja laskut.",
  products_coming_soon: "Tulossa pian",
  cockpit_upsell_io_title: "Toimistosi, joka ajattelee mukana",
  cockpit_upsell_io_text: "Yhdistä sähköpostitilisi Kjuupiin. Sähköpostit, liitteet ja viestit tallennetaan automaattisesti oikeaan projektiin, ja ne voidaan halutessasi tallentaa omalle palvelimellesi. Joka päivä saat yhteenvedon kaikista projekteista ja tärkeimmät kohdat kaikesta sisällöstä, ja tehtäväsi synkronoidaan kalenterisi tai to do -sovelluksesi kanssa.",
  cockpit_upsell_io_soon_title: "Ei vielä tilattavissa",
  cockpit_upsell_io_soon_text: "Kjuup.io julkaistaan pian. Pyydä tietoja nyt – ilmoitamme sinulle heti, kun voit tilata Kjuup.ion.",
  cockpit_upsell_io_planned_price: "Suunniteltu hinta",
  cockpit_upsell_io_cta_request: "Pyydä tietoja",
  kjuup_plus_abo_per_year: "/ vuosi",
  kjuup_plus_abo_per_month: "/ kk",
  kjuup_plus_abo_status_active: "Aktiivinen",
  kjuup_plus_abo_status_requested: "Irtisanomista pyydetty",
  kjuup_plus_abo_status_past_due: "Maksu erääntynyt",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Tilaus",
  kjuup_plus_abo_title: "Kjuup+-paketti",
  kjuup_plus_abo_seats_free_one: "1 paikka jäljellä",
  kjuup_plus_abo_billing: "Laskutus",
  kjuup_plus_abo_yearly: "Vuosittain",
  kjuup_plus_abo_monthly: "Kuukausittain",
  kjuup_plus_abo_amount: "Summa",
  kjuup_plus_abo_ends: "Päättyy",
  kjuup_plus_abo_renews: "Seuraava uusiminen",
  kjuup_plus_abo_next_invoice: "Seuraava lasku",
  kjuup_plus_abo_intro: "Esittelyhinta",
  kjuup_plus_abo_pending_tier: "Seuraavasta uusimisesta alkaen",
  kjuup_plus_abo_manual: "Kjuup+ on yrityksesi käytössä yksilöllisen sopimuksen perusteella.",
  kjuup_plus_abo_invoices: "Laskut",
  kjuup_plus_abo_invoice_paid: "Maksettu",
  kjuup_plus_abo_invoice_view: "Näytä",
  kjuup_plus_abo_invoices_less: "Näytä vähemmän",
  kjuup_plus_abo_member_hint: "Laskutusta ja irtisanomista hallinnoivat yrityksesi ylläpitäjät.",
  kjuup_plus_abo_withdraw: "Peruuta pyyntö",
  kjuup_plus_abo_cancel_note: "Syy (valinnainen)",
  kjuup_plus_abo_cancel_send: "Pyydä irtisanomista",
  kjuup_plus_abo_cancel: "Irtisano tilaus",
  cockpit_upsell_plus_f1: "Hallitse kaikkien työntekijöiden viestintää",
  cockpit_upsell_plus_f2: "Tiedota tietyille yrityksen käyttäjäryhmille",
  cockpit_upsell_plus_f3: "Tallenna sisäiset ryhmäkeskustelut",
  cockpit_upsell_plus_when_yearly: "vuosimaksulla",
  cockpit_upsell_plus_size_small: "1–50 työntekijää",
  cockpit_upsell_plus_size_large: "51–200 työntekijää",
  cockpit_upsell_plus_title: "Kjuup+ yrityksille",
  cockpit_upsell_plus_text: "Hallitse työntekijöitä, kirjoitusoikeuksia ja yrityksen viestintää yhdessä paikassa. Sisäiset kanavat pysyvät tiimilläsi, ulkoiset kanavat yhdistävät sinut projektikumppaneihin, ja tavoitat tietyt ryhmät suoraan. Kjuup+:n lisäksi voit tilata Kjuup.io-käyttöoikeuden työntekijäryhmille. Kjuup+ ja Kjuup.io voi yhdistää.",
  cockpit_upsell_plus_size: "Yrityksen koko",
  cockpit_upsell_plus_billing: "Laskutus",
  cockpit_upsell_plus_per_company: "/ yritys · kk, ilman alv:ta",
  cockpit_upsell_plus_onboarding: "Käyttöönotto- ja perehdytyskustannukset riippuvat yrityksen koosta",
  cockpit_upsell_plus_larger: "Suurempien yritysten hinnat pyynnöstä",
  cockpit_upsell_plus_cta: "Pyydä tarjous sitoumuksetta",
  cockpit_kpi_deadlines_tasks: "Määräajat ja tehtävät",
  cockpit_kpi_appointments: "Tapaamiset",
  cockpit_room_admin: "Projektien ja keskustelujen hallinta",
  cockpit_room_admin_sub: "Kaikki yrityksen projektit jäsenineen, medioineen ja keskusteluineen.",
  pro_todo_not_found: "Tämä tehtävä ei ole enää saatavilla.",
  cockpit_chip_overdue: "Myöhässä",
  cockpit_chip_today: "Tänään",
  cockpit_calendar_week: "Vk {{week}}",
  cockpit_prev_week: "Edellinen viikko",
  cockpit_next_week: "Seuraava viikko",
  cockpit_chip_requested: "Pyydetty",
  cockpit_todo_due: "Määräaika {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "keneltä: {{name}}",
  cockpit_todo_since: "alkaen {{when}}",
  cockpit_todo_no_date: "Ei päivämäärää",
  cockpit_todo_mark_done: "Merkitse valmiiksi",
  cockpit_my_tasks_title: "Omat tehtäväni",
  cockpit_today_tasks_group: "Tämän päivän tehtävät",
  cockpit_assign_none: "Ei vastuuhenkilöä",
  no_project_found: "Projektia ei löytynyt",
  cockpit_row_more_actions: "Lisää toimintoja",
  needs_date: "Määritä päivämäärä",
  cockpit_assign_proposal: "{{name}} tunnistettu – määritetäänkö?",
  cockpit_assign_proposal_confirm: "Määritä",
  cockpit_assign_proposal_dismiss: "Ohita",
  cockpit_priority_date: "Päivämäärä",
  todo_calendar_add: "Lisää kalenteriin",
  todo_calendar_remove: "Poista kalenterista",
  cockpit_todo_change_project: "Vaihda projekti",
  cockpit_todo_set_date: "Aseta päivämäärä",
  pro_todo_done_confirm: "Haluatko varmasti merkitä tämän tehtävän valmiiksi?",
  cockpit_task_delete_failed: "Tehtävän poistaminen epäonnistui.",
  cockpit_setup_title: "Viimeistele käyttöönotto",
  cockpit_setup_text: "Päätä, haluatko käyttää keskusteluja ja toimiiko Kjuup.io sähköpostiohjelmana vai vain projektien ja päiväraporttien kanssa.",
  cockpit_setup_cta: "Määritä nyt",
  cockpit_group_tasks: "Määräajat ja tehtävät",
  cockpit_group_appointments: "Tapaamiset",
  cockpit_report_no_activity: "Tässä projektissa ei ollut uusia viestejä tai sähköposteja viimeisen 24 tunnin aikana.",
  cockpit_report_room_unavailable: "Tämä projekti ei ole saatavilla.",
  cockpit_report_create_failed: "Päiväraportin luominen epäonnistui.",
  cockpit_report_created: "Päiväraportti luotu",
  addon_enable_confirm: "Otetaanko lisäosa käyttöön?",
  addon_enable: "Ota käyttöön",
  addon_enabled: "Lisäosa otettu käyttöön",
  nav_email: "Sähköposti",
  nav_my_cockpit: "Oma cockpit",
  nav_news: "Uutiset",
  nav_recommend: "Suosittele",
  pro_todo_status_done: "Valmis",
  pro_todo_status_open: "Avoin",
  v2_todo_remove: "Poista",
  pro_todo_search_people: "Hae henkilöitä",
  pro_todo_clear: "Tyhjennä",
  pro_todo_assigned: "(määritetty)",
  pro_todo_no_people: "Henkilöitä ei löytynyt",
  pro_todo_search_rooms: "Hae projekteja",
  pro_todo_no_rooms_match: "Mikään projekti ei vastaa hakua ”{{q}}”",
  pro_todo_no_rooms: "Projekteja ei löytynyt",
  pro_todo_activity: "Toiminta",
  pro_todo_show_less: "Näytä vähemmän",
  pro_todo_show_all: "Näytä kaikki ({{n}})",
  pro_todo_due: "Määräaika",
  pro_todo_room: "Projekti",
  pro_todo_select_room: "Valitse projekti",
  pro_todo_status: "Tila",
  pro_todo_more: "Lisää",
  pro_todo_edit_title: "Muokkaa tehtävää",
  pro_todo_description: "Kuvaus",
  pro_todo_created_by: "Luonut",
  pro_todo_chat: "Keskustelu",
  navigate_to_source: "Siirry lähteeseen",
  todo_calendar_connect_title: "Kalenteria ei ole yhdistetty",
  todo_calendar_connect_body_web: "Yhdistä kalenteri kalenterisynkronoinnin asetuksissa, jotta voit lisätä tehtäviä siihen.",
  todo_calendar_connect: "Yhdistä",
  todo_calendar_removed: "Poistettu kalenteristasi",
  todo_calendar_added_later: "Lisätty. Kalenteriisi ei saatu yhteyttä; Kjuup yrittää myöhemmin uudelleen.",
  todo_calendar_added: "Lisätty kalenteriisi",
  todo_calendar_no_date: "Vain päivämäärällinen tehtävä voidaan lisätä kalenteriin.",
  todo_calendar_failed: "Kalenterin päivittäminen epäonnistui. Yritä uudelleen.",
  todo_calendar_date_title: "Ei vielä päivämäärää",
  todo_calendar_date_save: "Aseta päivämäärä ja lisää",
  todo_calendar_date_body_web: "Tällä merkityllä tehtävällä ei ole vielä päivämäärää. Aseta päivämäärä, jotta voit lisätä sen kalenteriisi.",
  kjuup_io_setup_saved: "Määritys tallennettu",
  kjuup_io_setup_step: "Vaihe",
  kjuup_io_setup_chats_title: "Haluatko käyttää keskusteluja?",
  kjuup_io_setup_email_title: "Missä haluat lukea sähköpostisi?",
  kjuup_io_setup_chats_sub: "Keskustelut kollegoiden ja projektikumppaneiden kanssa ovat valinnaisia. Voit näyttää tai piilottaa ne cockpitissa milloin tahansa.",
  kjuup_io_setup_email_sub: "Tämä valinta kertoo vain, käytätkö sähköpostiohjelmaa Kjuupissa vai jatkatko nykyisellä sähköpostiohjelmallasi, kuten Outlookilla tai muulla. Voit vaihtaa myöhemmin.",
  kjuup_io_setup_chats_yes: "Kyllä, näytä keskustelut",
  kjuup_io_setup_chats_yes_text: "Viestit sisältää keskustelut ja sähköpostit. Projekteissa on ryhmäkeskustelut kaikille osallisille.",
  kjuup_io_setup_chats_no: "Ei, työskentele ilman keskusteluja",
  kjuup_io_setup_chats_no_text: "Keskustelut on piilotettu. ”Viestit” muuttuu muotoon ”Sähköposti”; projektit, tehtävät ja päiväraportit säilyvät.",
  kjuup_io_setup_email_client: "Sähköpostiohjelma Kjuupissa",
  kjuup_io_setup_email_client_text: "Lue ja vastaa sähköposteihin suoraan Kjuupissa.",
  kjuup_io_setup_email_reports: "Nykyinen sähköpostiohjelma",
  kjuup_io_setup_email_reports_text: "Jatka lukemista ja vastaamista nykyisessä ohjelmassasi, kuten Outlookissa tai muussa.",
  kjuup_io_setup_skip: "Myöhemmin",
  next: "Seuraava",
  kjuup_io_setup_finish: "Viimeistele käyttöönotto",
  today_label: "tänään",
  tomorrow_label: "huomenna",
  cockpit_todo_overdue: "myöhässä",
  cockpit_report_management_fazit: "Yhteenveto johdolle",
  cockpit_todo_appointment: "Tapaaminen",
  cockpit_todo_deadline: "Määräaika",
  cockpit_todo_deadline_define: "Aseta määräaika",
  pro_todo_status_acknowledged: "Vahvistettu",
  pro_todo_responsible: "Vastuuhenkilö",
  pro_todo_notice_confirmed: "Vahvistettu keskustelussa",
  pro_todo_notice_sent_at: "Viesti lähetetty",
  pro_todo_notice_again: "Lähetä viesti uudelleen",
  pro_todo_notice_send: "Ilmoita Kjuup-viestillä",
  pro_todo_add_assignee: "Lisää",
  pro_todo_edit: "Muokkaa",
  pro_todo_change_room: "Vaihda projekti",
  pro_todo_due_on: "Määräaika",
  pro_todo_edit_due: "Muokkaa määräaikaa",
  pro_todo_no_date: "Ei päivämäärää",
  pro_todo_edit_description: "Muokkaa kuvausta",
  pro_todo_no_description: "Ei vielä kuvausta",
  pro_todo_title_label: "Otsikko",
  pro_todo_title_placeholder: "Kirjoita otsikko...",
  pro_todo_task: "Tehtävä",
  pro_todo_what: "Mitä pitää tehdä?",
  pro_todo_source_email: "Sähköposti",
  pro_todo_sources: "Lähteet",
  previous: "Edellinen",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (enintään {max} työntekijää)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (enintään {max} työntekijää)",
  kjuup_plus_abo_status_ends: "Päättyy {date}",
  kjuup_plus_abo_seats_over: "Yli {max} työntekijää – Kjuup ottaa sinuun yhteyttä ja tekee yksilöllisen tarjouksen.",
  kjuup_plus_abo_seats_next: "Jos työntekijöitä tulee lisää, paketti vaihtuu automaattisesti pakettiin {next} (suhteutettu laskutus).",
  kjuup_plus_abo_seats_used: "{used}/{total} paikkaa käytössä",
  kjuup_plus_abo_seats_free: "{count} paikkaa jäljellä",
  kjuup_plus_abo_intro_until: "{date} asti",
  kjuup_plus_abo_invoice_open: "Avoin · erääntyy {date}",
  kjuup_plus_abo_invoices_all: "Näytä kaikki ({count})",
  kjuup_plus_abo_requested_hint: "Irtisanomista pyydetty {date}. Kjuup vahvistaa sen kauden lopussa ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup käsittelee pyyntösi ja vahvistaa irtisanomisen kauden lopussa ({end}). Siihen asti Kjuup+ pysyy aktiivisena.",
  kjuup_plus_abo_withdrawn: "Irtisanomispyyntö peruttu",
  kjuup_plus_abo_requested: "Irtisanomista pyydetty",
  cockpit_upsell_plus_intro_hint: "ensimmäiset {months} kuukautta, sitten {price}",
  cockpit_upsell_plus_badge: "TUTUSTUMISHINTA {months} KUUKAUDEKSI",
  calendar_syncing: "Päivitetään kalenterista…",
  calendar_sync_up_to_date: "Kalenteri on ajan tasalla",
  calendar_sync_failed: "Synkronointi epäonnistui",
  delete_multiple_tasks_confirm: "Haluatko varmasti poistaa {count} ToDo-tehtävää?",
  todos_deleted_count: "{count} ToDo-tehtävää poistettu",
  todos_deleted_partial: "{ok} ToDo-tehtävää poistettu, {fail} epäonnistui",
  todo_unknown: "Tuntematon",
  todo_created_from_message: "Tehtävä luotu tästä viestistä",
  kjuup_io_todo_calendar_trial_ended_note: "Kalenterin synkronointi · Tilaa",
  kjuup_io_todo_calendar_nudge: "Synkronoidaanko tämä ToDo kalenteriisi?",
  kjuup_io_todo_calendar_nudge_cta: "Aktivoi Kjuup.io",
  todo_confirmed: "ToDo vahvistettu",
  pro_todo_bulk_delete_title: "Poistetaanko {{n}} tehtävää?",
  pro_todo_previous_none_own: "Muut ovat antaneet myöhässä olevat tehtävät sinulle, ja vain he voivat poistaa ne.",
  pro_todo_previous_none: "Ei myöhässä olevia tehtäviä",
  pro_todo_previous_title: "Poistetaanko {{n}} myöhässä olevaa tehtävää?",
  pro_todo_previous_text: "Kaikki aiempien päivien avoimet tehtäväsi poistetaan.",
  pro_todo_previous_skipped: "Muiden sinulle antamat tehtävät säilyvät: {{n}}.",
  unassign_task_confirm: "Haluatko peruuttaa osoituksesi tähän tehtävään?",
  unassign_label: "Peruuta",
  pro_todo_delete_title: "Poista tehtävä",
  pro_todo_today: "Tänään",
  pro_todo_yesterday: "Eilen",
  pro_todo_since_yesterday: "Eilisestä lähtien",
  pro_todo_mark_open: "Merkitse avoimeksi",
  verify_completion: "Vahvista",
  new_label: "Uusi",
  bookmarked_no_mylist: "Kirjanmerkittyjä tehtäviä ei voi lisätä Omaan listaan",
  delete_only_own: "Voit poistaa vain itse luomiasi tehtäviä",
  todo_clear_all: "Tyhjennä kaikki",
  pro_todo_of_completed: "{{done}}/{{total}} valmiina",
  pro_todo_pick_date: "Valitse päivämäärä",
  pro_todo_show_day: "Näytä päivä",
  todo_adjust_list: "Muokkaa listaa",
  pro_todo_section_upcoming: "Tulossa",
  pro_todo_section_done: "Valmis",
  pro_todo_room_empty_today: "Tässä projektissa ei ole tehtäviä tänään",
  pro_todo_room_empty_day: "Tässä projektissa ei ole tehtäviä tänä päivänä",
  pro_todo_delete_previous: "Poista kaikki",
  todo_my_list_empty: "Päiväsi on tyhjä",
  todo_my_list_empty_hint: "Lisää tehtäviä napsauttamalla ”Muokkaa listaa”",
  pro_todo_empty_title: "Täällä ei ole mitään",
  pro_todo_empty_hint: "Yksikään tehtävä ei vastaa tätä näkymää.",
  pro_todo_selected: "{{n}} valittu",
  delete_selected_count: "Poista ({count})",
  pro_todo_adjust_done: "Valmis",
  pro_todo_deleting: "Poistetaan...",
  pro_todo_reopen: "Avaa tehtävä uudelleen",
  pro_todo_step_done: "Tehty",
  move_back_in_progress: "Takaisin kesken",
  pro_todo_mark_not_started: "Merkitse aloittamattomaksi",
  back_into_in_progress: "Takaisin kesken",
  pro_todo_mark_in_progress: "Merkitse keskeneräiseksi",
  unassign_todo: "Peruuta ToDo-osoitus",
  pro_todo_open_room: "Avaa projekti",
  pro_todo_new_task: "Uusi tehtävä",
  select_user_back_to_in_progress: "Valitse käyttäjä, joka palautetaan tilaan Käynnissä",
  cockpit_email_accounts_n_many: "{{n}} tiliä yhdistetty",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-yhteystiedot",
  combined_tab_teams: "Teams-yhteystiedot",
  combined_bridge_failed: "Teams-kopiota ei voitu luoda.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- ja Teams-yhteystiedot: luodaan uusi ryhmä, joka näkyy myös Microsoft Teamsissa.",
  teams_new_chat_title: "Uusi Teams-keskustelu",
  teams_new_chat_topic: "Ryhmän nimi (valinnainen)",
  teams_new_chat_start: "Aloita keskustelu",
  teams_new_chat_creating: "Luodaan keskustelua…",
  teams_new_chat_forbidden: "Microsoft Teams ei salli tätä keskustelua (esim. organisaatiosi ulkopuolinen henkilö tai IT-osastosi käytäntö).",
  teams_new_chat_too_many: "Liian monta henkilöä yhteen keskusteluun.",
  teams_new_chat_type_hint: "Kirjoita nimi hakeaksesi organisaatiostasi.",
  teams_new_chat_directory_forbidden: "Organisaatiosi ei salli hakemistohakua. Näytetään vain henkilöt Teams-keskusteluistasi.",
  teams_new_chat_account: "Tili",
};
